import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MattersListing from './mattersListing';
import { useLocation } from 'react-router-dom';
import { MatterTabSections } from '../../interface/matter';
import AddEditTransactionHeader from '../dashboard/addTransaction/addEditTransactionHeader';
import { usePage } from '../../context/PageContext';
import MatterRequestListing from '../conflictSearch/matterRequestListing';
import { useNavigationStack } from '../../context/NavigationStackContext';
import { ROUTES } from '../../constants/constants';
import { useAnalytics } from '../../hooks/useAnalytics';
import { AnalyticsPage } from '../../interface/analytics';
import CustomTabs from '../customTabs/customTabs';
import { useFetchUserParameters } from '../../hooks/useFetchUserParameters';
import { ParameterEntityType } from '../../interface/parameters';
import { ProductName } from '../../interface/system';
import { useSystemInfo } from '../../context/SystemInfoContext';

const MatterTabView = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { setTitle } = usePage();
  const { trackPage } = useAnalytics();
  const { clear, push } = useNavigationStack();
  const { systemParams } = useSystemInfo();
  const { data: parametersDetails } = useFetchUserParameters({
    parametersToGet: ParameterEntityType.FEATURES_IN_USE,
  });
  const showMatterRequestsTab =
    parametersDetails?.parameters?.featuresInUseParameters?.matterRequestInUse &&
    systemParams?.systemInfo?.productName !== ProductName.LAKIMIES;

  const fromTab = location?.state?.fromTab ?? MatterTabSections.matters;

  const [selectedTab, setSelectedTab] = useState<string>(fromTab.toString());
  const handleHome = () => {
    clear();
    push(ROUTES.DASHBOARD);
  };

  useEffect(() => {
    trackPage(AnalyticsPage.MATTER_LISTING);
  }, [trackPage]);

  useEffect(() => {
    setTitle(
      <AddEditTransactionHeader
        title={t('common:features.matters')}
        showMenu
        showSettings
        handleHome={handleHome}
      />,
    );
  }, []);

  const items = useMemo(
    () => [
      {
        key: MatterTabSections.matters.toString(),
        label: t('common:tab.matters'),
        children: <MattersListing />,
      },
      ...(showMatterRequestsTab
        ? [
            {
              key: MatterTabSections.matterRequests.toString(),
              label: t('common:tab.matterRequests'),
              children: <MatterRequestListing />,
            },
          ]
        : []),
    ],
    [t, showMatterRequestsTab],
  );

  if (!showMatterRequestsTab) {
    return <MattersListing />;
  }

  return <CustomTabs activeKey={selectedTab} onChange={setSelectedTab} items={items} />;
};

export default MatterTabView;
